import React, { Component } from "react"
// import FromToCities from "base_components/FromToCities"
import DatePicker from "base_components/DatePicker"
import InputPassengersNumber from "base_components/InputPassengersNumber"
import CabinClass from "base_components/CabinClass"
import { withRouter } from "react-router-dom"
import { compose, pure } from "recompose"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { createStructuredSelector } from "reselect"
import { getStateFromProps } from "utilities"
import { searchFlights } from "../thunks"
import {
  Stylebtn,
  FlexRow,
  DepartureDate,
  PassengersNumber,
  TabContainer,
  CabinClassFull
} from "../elements.js"
import Alert from "base_components/BannerAlert"
import { validateJoi, roundtripSearchSchema } from "shared/validations"
import InputAutoComplete from "base_components/InputAutoComplete"
import features from "features"
class RoundTrip extends Component {
  constructor(props) {
    super(props)
    this.destination = React.createRef()
    this.depDate = React.createRef()
    this.retDate = React.createRef()
    this.state = {
      ...getStateFromProps({ props }),
      message: "",
      alertVisible: false,
      originObj: [],
      destinationObj: []
    }
  }

  componentDidMount = () => {
    let originObj = this.props.airports.filter(
      i => i.code === this.state.origin
    )
    let destinationObj = this.props.airports.filter(
      i => i.code === this.state.destination
    )
    this.setState({ originObj, destinationObj })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.query !== this.props.query) {
      let data = getStateFromProps({ props: this.props })
      let filteredOrigin = this.props.airports.filter(
        i => i.code === data.origin
      )
      let filteredDestination = this.props.airports.filter(
        i => i.code === data.destination
      )
      this.setState({
        origin: data.origin,
        originObj: filteredOrigin,
        destinationObj: filteredDestination,
        departure_date: data.customDDate,
        customDDate: data.customDDate,
        passengers: data.passengers,
        destination: data.destination,
        cabin_class: data.cabin_class
      })
    }
  }

  getPassengers = (type, value, index) => {
    let passengers = Object.assign({}, this.state.passengers)
    let { departure_date, return_date, customRDate } = this.state

    passengers[type] = value
    let test = Object.values(passengers)
    let sum = test.reduce((a, b) => a + b)
    this.setState(
      {
        passengerSum: sum,
        passengers,
        return_date: customRDate,
        customRDate: customRDate,
        departure_date: departure_date,
        customDDate: departure_date
      },
      () => {
        this.props.history.replace({
          search: `?trip_type=roundtrip&departure_date=${
            this.state.departure_date
          }&origin=${this.state.origin}&destination=${
            this.state.destination
          }&cabin_class=${this.state.cabin_class.value}&adults=${
            this.state.passengers.adults
          }&children=${this.state.passengers.children}&infants=${
            this.state.passengers.infants
          }&customDDate=${this.state.customDDate ? this.state.customDDate : ""}`
        })
      }
    )
  }

  handleDateSelect = date => {
    let { return_date, customRDate } = this.state
    if (return_date) {
      let date4 = new Date(date)
      let date2 = new Date(return_date)

      let diffDays = Math.floor(
        (Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate()) -
          Date.UTC(date4.getFullYear(), date4.getMonth(), date4.getDate())) /
          (1000 * 60 * 60 * 24)
      )

      if (diffDays < 0) {
        this.handleReturnDate(date)
      }
    }
    this.setState(
      {
        departure_date: date,
        customDDate: `${("0" + (date.getMonth() + 1)).slice(-2)}/${(
          "0" + date.getDate()
        ).slice(-2)}/${date.getFullYear()}`,
        // return_date: customRDate,
        customRDate: customRDate
      },
      () => {
        this.props.history.replace({
          search: `?trip_type=roundtrip&departure_date=${this.state.departure_date}&origin=${this.state.origin}&destination=${this.state.destination}&cabin_class=${this.state.cabin_class.value}&adults=${this.state.passengers.adults}&children=${this.state.passengers.children}&infants=${this.state.passengers.infants}&customDDate=${this.state.customDDate}`
        })
      }
    )
    this.retDate.current.childNodes[0].click()
  }
  handleReturnDate = date => {
    setTimeout(() => {
      let { departure_date, customDDate } = this.state
      this.setState({
        return_date: date,
        customRDate: `${("0" + (date.getMonth() + 1)).slice(-2)}/${(
          "0" + date.getDate()
        ).slice(-2)}/${date.getFullYear()}`,
        departure_date: customDDate,
        customDDate: customDDate
      })
    }, 200)
    // debugger
  }

  handleSelect = cabin_class => {
    let { departure_date, return_date, customDDate, customRDate } = this.state
    this.setState(
      {
        cabin_class,
        return_date: customRDate,
        customRDate: customRDate,
        departure_date: customDDate,
        customDDate: customDDate
      },
      () => {
        this.props.history.replace({
          search: `?trip_type=roundtrip&departure_date=${
            this.state.departure_date
          }&origin=${this.state.origin}&destination=${
            this.state.destination
          }&cabin_class=${this.state.cabin_class.value}&adults=${
            this.state.passengers.adults
          }&children=${this.state.passengers.children}&infants=${
            this.state.passengers.infants
          }&customDDate=${customDDate ? customDDate : ""}`
        })
      }
    )
  }
  // handleSamePlace = () => {
  //   let message = "Origin and Destination should not be same."
  //   this.setState(
  //     {
  //       alertVisible: true,
  //       message
  //     },
  //     () => {
  //       setTimeout(() => {
  //         this.setState({ alertVisible: false })
  //       }, 2000)
  //     }
  //   )
  // }

  search = () => {
    let {
      departure_date,
      passengers,
      origin,
      destination,
      cabin_class,
      return_date,
      customDDate,
      customRDate
    } = this.state

    validateJoi(roundtripSearchSchema, {
      origin: origin == "undefined" ? "" : origin,
      destination: destination == "undefined" ? "" : destination,
      customDDate,
      customRDate
    })
      .then(() => {
        let pathname =
          this.props.location.pathname === "/search" ? "/search2" : "/search"
        this.props.history.push({
          pathname,
          search: `?trip_type=roundtrip&departure_date=${departure_date}&return_date=${return_date}&origin=${origin}&destination=${destination}&cabin_class=${cabin_class.value}&adults=${passengers.adults}&children=${passengers.children}&infants=${passengers.infants}&customDDate=${customDDate}&customRDate=${customRDate}`
        })
      })
      .catch(error => {
        const message = error.params.label
        this.setState(
          {
            alertVisible: true,
            message
          },
          () => {
            setTimeout(() => {
              this.setState({ alertVisible: false })
            }, 2000)
          }
        )
      })
  }

  getTo = value => {
    let {
      departure_date,
      customDDate,
      passengers,
      cabin_class,
      destination
    } = this.state
    if (typeof value === "object") {
      // if (value.code !== this.state.origin) {
      let filteredDestination = this.props.airports.filter(
        i => i.code === value.code
      )
      this.setState(
        {
          origin: this.state.origin,
          destinationObj: filteredDestination,
          destination: value.code,
          originObj: this.state.originObj,
          departure_date: customDDate,
          customDDate
        },
        () => {
          this.props.history.replace({
            search: `?trip_type=roundtrip&departure_date=${departure_date}&origin=${
              this.state.origin
            }&destination=${this.state.destination}&cabin_class=${
              cabin_class.value
            }&adults=${passengers.adults}&children=${
              passengers.children
            }&infants=${passengers.infants}&customDDate=${
              customDDate ? customDDate : ""
            }`
          })
        }
      )
      this.depDate.current.childNodes[0].click()
      // } else {
      //   this.handleSamePlace()
      // }
    }
    // else if (typeof value === "string" && !value.includes(",")) {
    //   this.setState({
    //     origin: this.state.origin,
    //     destinationObj: [],
    //     destination: "",
    //     originObj: this.state.originObj,
    //     departure_date: customDDate,
    //     customDDate
    //   })
    // }
  }

  getFrom = value => {
    let {
      departure_date,
      customDDate,
      passengers,
      cabin_class,
      destination
    } = this.state
    if (typeof value === "object") {
      // if (value.code !== this.state.destination) {
      let filteredOrigin = this.props.airports.filter(
        i => i.code === value.code
      )
      this.setState(
        {
          origin: value.code,
          originObj: filteredOrigin,
          destination,
          destinationObj: this.state.destinationObj,
          departure_date: customDDate,
          customDDate
        },
        () => {
          this.props.history.replace({
            search: `?trip_type=roundtrip&departure_date=${departure_date}&origin=${
              this.state.origin
            }&destination=${this.state.destination}&cabin_class=${
              cabin_class.value
            }&adults=${passengers.adults}&children=${
              passengers.children
            }&infants=${passengers.infants}&customDDate=${
              customDDate ? customDDate : ""
            }`
          })
        }
      )
      this.destination.current.focus()
      // } else {
      //   this.handleSamePlace()
      // }
    }
    // else if (typeof value === "string" && !value.includes(",")) {
    //   this.setState({
    //     origin: "",
    //     originObj: [],
    //     destination,
    //     destinationObj: this.state.destinationObj,
    //     departure_date: customDDate,
    //     customDDate
    //   })
    // }
  }

  closeAlert = () => {
    this.setState({ alertVisible: false })
  }

  render() {
    let {
      origin,
      destination,
      destinationObj,
      message,
      alertVisible,
      originObj
    } = this.state
    return (
      <TabContainer>
        <FlexRow className="RoundtripCol">
          <InputAutoComplete
            placeholder="From"
            onChange={this.getFrom}
            arrow
            cities={this.props.airports}
            initialValue={
              originObj.length
                ? `${originObj[0].value} (${originObj[0].code})`
                : ``
            }
          />
          <InputAutoComplete
            placeholder="To"
            inputRef={this.destination}
            cities={this.props.airports}
            onChange={this.getTo}
            initialValue={
              destinationObj.length
                ? `${destinationObj[0].value} (${destinationObj[0].code})`
                : ``
            }
          />
        </FlexRow>
        <DepartureDate ref={this.depDate}>
          <DatePicker
            date={this.state.departure_date}
            handleChange={this.handleDateSelect}
          />
        </DepartureDate>
        <DepartureDate ref={this.retDate} style={{ paddingRight: "0px" }}>
          <DatePicker
            placeholder="Return Date"
            date={this.state.return_date}
            handleChange={this.handleReturnDate}
            minDate={new Date(this.state.departure_date)}
          />
        </DepartureDate>
        <PassengersNumber className="dummy" fromRoundTRip>
          <InputPassengersNumber
            inputName="Passengers"
            initialValue={this.state.passengers}
            onChange={this.getPassengers}
          />
        </PassengersNumber>
        <CabinClassFull fromRoundTRip>
          <CabinClass
            flex
            height="60px"
            fontSize="16px"
            handleSelect={this.handleSelect}
            value={this.state.cabin_class}
          />
        </CabinClassFull>
        <Stylebtn onClick={this.search}>
          SEARCH{" "}
          <img
            alt="img"
            src="/images/plane.png"
            style={{ maxWidth: "18px", marginLeft: "9px" }}
          />
        </Stylebtn>
        <Alert
          message={message}
          visible={alertVisible}
          close={this.closeAlert}
        />
      </TabContainer>
    )
  }
}

const mapToState = () =>
  createStructuredSelector({
    airports: features.landing.selectors.selectAirportList()
  })

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      searchFlights
    },
    dispatch
  )

export default compose(
  withRouter,
  component =>
    connect(
      mapToState,
      mapDispatch
    )(component),
  pure
)(RoundTrip)
